/**
 * Created by hiro on 2020/07/23.
 * axios 数据拦截
 */

import axios from 'axios'
import {HTTP_ERR_UNAUTHORIZED} from '@/constant/api_status'
import {getToken} from '@utils/auth'
import store from '../store'


axios.interceptors.request.use(function (config) {
    // 获取token
    const TOKEN = getToken()
    if (TOKEN) {
        config.headers.common['Authorization'] = TOKEN
    }
    window.NProgress.start() // 进度条开始
    return config
})
// 劫持响应数据
axios.interceptors.response.use(function (response) {
    window.NProgress.done()

    if (response.data.code === HTTP_ERR_UNAUTHORIZED) {
        store.dispatch('logOut').then(() => {
            window.location.reload()
        })
        return
    }

    // 对响应数据做点什么
    return response
}, function (error) {
    window.NProgress.done()
    //  处理错误信息
    // let errMsg = throwHTTPError(error)
    // 对响应错误做点什么
    return Promise.reject(error)
})


export default axios